import React, { useState } from 'react';
import { Tabs } from 'antd';
import { openSuccessNotification } from '../../utils/notifications';
import { userProfileService } from '../../services/userProfile';
import { PersonalDetails } from './components/PersonalDetails';
import { Security } from './components/Security';
import { Spinner } from '../../components/Spinner';
import { useContext } from 'react';
import { UserContext } from '../../contexts/userContext';
import { showApiErrors } from '../../utils/showApiErrors';

const { TabPane } = Tabs;
export const UserProfile = () => {
  const { refresh, userInfo } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const updateUser = async (values) => {
    setLoading(true);
    try {
      await userProfileService.editUserDetails(values, userInfo.id);
      openSuccessNotification({ message: 'Uspješno sačuvano' });
      setLoading(false);
      refresh();
    } catch (e) {
      console.log(e);
      showApiErrors(e);
      setLoading(false);
    }
  };
  const updateUserPassword = async (values) => {
    setLoading(true);
    try {
      await userProfileService.changePassword(values, userInfo.id);
      openSuccessNotification({ message: 'Uspješno sačuvano' });
    } catch (e) {
      showApiErrors(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      {loading ? (
        <Spinner></Spinner>
      ) : (
        <>
          <h2>Profil</h2>
          <Tabs>
            <TabPane tab="Lični podaci" key="1">
              <PersonalDetails initialData={userInfo} updateUser={updateUser}></PersonalDetails>
            </TabPane>
            <TabPane tab="Sigurnost" key="2">
              <Security updateUserPassword={updateUserPassword}></Security>
            </TabPane>
          </Tabs>
        </>
      )}
    </div>
  );
};
